import { useEffect, useState } from "react";
import { List, X } from "@phosphor-icons/react";

const links = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "team", label: "Team" },
  { id: "insights", label: "Insights" },
  { id: "contact", label: "Contact" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FDFBF7]/85 border-b border-[#D1CEC5]/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => scrollTo("top")}
          className="flex items-center gap-3 text-left"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_chartered-anand/artifacts/jpojo6ch_logo_download-new.jpg"
            alt="CA India · ICAI member firm"
            className="h-10 w-10 object-contain"
            data-testid="header-ca-india-logo"
          />
          <div className="leading-tight">
            <div className="font-serif-display text-lg text-[#1B3B2B]">
              Anand Aditya <span className="text-[#D4AF37]">&amp;</span> Co.
            </div>
            <div className="overline text-[10px] mt-0.5">Chartered Accountants</div>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className="text-sm text-[#1B3B2B] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="header-cta"
            onClick={() => scrollTo("contact")}
            className="btn-primary !py-2.5 !px-5 text-xs"
          >
            Book Consultation
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[#D1CEC5] bg-[#FDFBF7]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}-link`}
                onClick={() => {
                  setOpen(false);
                  scrollTo(l.id);
                }}
                className="text-left text-base text-[#1B3B2B]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-header-cta"
              onClick={() => {
                setOpen(false);
                scrollTo("contact");
              }}
              className="btn-primary mt-2 w-fit"
            >
              Book Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
